import { cn } from '@/lib/utils';

export default function Logo({ variant = 'dark', className }) {
  const src = variant === 'light' ? '/logo-white.png' : '/logo-dark.png';
  return (
    <img
      src={src}
      alt="Rodotrack — Tecnologia Satelital"
      data-testid="brand-logo"
      className={cn('w-auto object-contain', variant === 'light' ? 'h-12' : 'h-11', className)}
    />
  );
}